module.exports = __webpack_public_path__ + "static/media/20ECE16.0d6973e7.jpg";